<template>
  <section class="events-component-toolbar">
    <div class="events-component-toolbar__row-one">
      <div class="events-component-toolbar__row-one__cont-select-matchs">
        <div class="events-component-toolbar__row-one__cont-select-matchs__label">
          Jornada:
        </div>
        <div class="events-component-toolbar__row-one__cont-select-matchs__selector">
          <BField position="is-centered" type="is-info" class="select-statistics">
            <BSelect v-model="selectedRound" placeholder="Seleccione" expanded>
              <option v-for="round of gamesByRound" :key="round.key" :value="round">{{
                round.abbreviation2
              }}</option>
            </BSelect>
          </BField>
        </div>
      </div>
      <div class="events-component-toolbar__row-one__cont-select-games">
        <div class="events-component-toolbar__row-one__cont-select-games__label">
          Partido:
        </div>
        <div class="events-component-toolbar__row-one__cont-select-games__selector">
          <BField position="is-centered" type="is-info" class="select-statistics">
            <BSelect v-model="selectedGame" placeholder="Seleccione" expanded>
              <option v-for="game of selectedRound.games" :key="game.game_id" :value="game">
                {{ game.homeTeam.colloquial_name }} vs {{ game.awayTeam.colloquial_name }}
              </option>
            </BSelect>
          </BField>
        </div>
      </div>
    </div>
    <div class="events-component-toolbar__row-two">
      <div class="events-component-toolbar__row-two__cont-select-category">
        <div class="events-component-toolbar__row-two__cont-select-category__label">
          Categoría:
        </div>
        <div class="events-component-toolbar__row-two__cont-select-category__selector">
          <BField position="is-centered" type="is-info" class="select-statistics">
            <BSelect v-model="selectedCategory" placeholder="Seleccione" expanded>
              <option v-for="category of categories" :value="category" :key="category.action_id">{{
                category.name
              }}</option>
            </BSelect>
          </BField>
        </div>
      </div>
      <div class="events-component-toolbar__row-two__cont-select-limit">
        <div class="events-component-toolbar__row-two__cont-select-limit__label">
          Limite de tiempo<span class="events-component-toolbar__row-two__cont-select-limit__label__span-movil">
            por evento</span
          >
          <span class="events-component-toolbar__row-two__cont-select-limit__label__span">(en segundos)</span>:
        </div>
        <div class="events-component-toolbar__row-two__cont-select-limit__input">
          <BInput v-model="selectedTime" id="seg" type="text" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'EventsComponentToolbar',
  components: {},
  props: {
    gamesByRound: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedRound: {
        games: [],
      },
      selectedGame: {},
      selectedCategory: {},
      selectedTime: 25,
    };
  },
  computed: {},
  watch: {
    gamesByRound: {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.length) {
          this.selectedRound = newValue[0];
        }
      },
    },
    categories: {
      immediate: true,
      handler(newValue) {
        if (newValue.length > 0) {
          this.selectedCategory = newValue[1];
        }
      },
    },
    selectedRound(newValue) {
      if (newValue) {
        this.selectedGame = newValue.games[0];
      }
    },
    selectedGame(newValue) {
      this.$emit('change-game-id', newValue);
    },
    selectedCategory(newValue) {
      this.$emit('change-category', newValue);
    },
    selectedTime: {
      immediate: true,
      handler(newValue) {
        this.$emit('change-time', Number(newValue));
      },
    },
  },
  methods: {},
  created() {},
};
</script>
<style>
.events-component-toolbar input {
  text-align: center;
  font-size: 20px;
  font-family: 'Avenir-Bold';
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.75;
  letter-spacing: -0.4px;
  text-align: center;
  color: #132739;
}
</style>
<style lang="scss" scoped>
.events-component-toolbar {
  width: 100%;
  height: 56px;
  margin-top: 20px;
  display: inline-flex;
  @media screen and (max-width: 660px) {
    display: inline-block;
    height: auto;
    margin-top: 4px;
  }
  &__row-one {
    width: 37.69%;
    height: 56px;
    display: inline-flex;
    @media screen and (max-width: 660px) {
      width: 98%;
    }
    &__cont-select-matchs {
      width: 25.1%;
      height: 56px;
      margin-left: 2.09%;
      @media screen and (max-width: 660px) {
        width: 27.19%;
        margin-left: 0%;
      }
      &__label {
        width: 100%;
        height: 20px;
        font-size: 12px;
        font-family: 'Roboto-Medium';
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 20px;
        letter-spacing: normal;
        text-align: left;
        color: #95a3ae;
      }
    }
    &__cont-select-games {
      width: 62.76%;
      height: 56px;
      margin-left: 24px;
      margin-left: 5.02%;
      @media screen and (max-width: 660px) {
        width: 70.6%;
        margin-left: 2.02%;
      }
      &__label {
        width: 100%;
        height: 20px;
        font-size: 12px;
        font-family: 'Roboto-Medium';
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 20px;
        letter-spacing: normal;
        text-align: left;
        color: #95a3ae;
      }
    }
  }
  &__row-two {
    width: 62.3%;
    height: 56px;
    display: inline-flex;

    @media screen and (max-width: 660px) {
      width: 98%;
      margin-top: 5px;
    }
    &__cont-select-category {
      width: 62.78%;
      height: 56px;
      @media screen and (max-width: 1220px) {
        width: 55%;
      }
      &__label {
        width: 100%;
        height: 20px;
        font-size: 12px;
        font-family: 'Roboto-Medium';
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 20px;
        letter-spacing: normal;
        text-align: left;
        color: #95a3ae;
      }
    }
    &__cont-select-limit {
      width: 32.91%;
      height: 56px;
      margin-left: 3.03%;
      @media screen and (max-width: 1220px) {
        width: 40.69%;
      }
      &__label {
        width: 100%;
        height: 20px;
        font-size: 12px;
        font-family: 'Roboto-Medium';
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 20px;
        letter-spacing: normal;
        text-align: left;
        color: #95a3ae;

        &__span {
          @media screen and (max-width: 990px) {
            display: none;
          }
        }
        &__span-movil {
          @media screen and (max-width: 440px) {
            display: none;
          }
        }
      }
    }
  }
}
</style>
